import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { globals } from '../globals';
import { Irradiacao } from '../models/irradiacao';

@Injectable({
  providedIn: 'root'
})
export class IrradiacaoService {

  constructor(private http: HttpClient) { }

  buscarPorIbge(ibge: string) {
    return this.http.get<Irradiacao>(globals.apiUrl + '/api/Irradiacao/BuscarPorIbge',
      { params: new HttpParams().set('ibge', ibge) });
  }
}
